import { DateStr, toDateRange, today } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { EqualMd5ReportForm } from './form';
import { EqualMd5ReportResult } from './result';
import { EqualMd5Report } from './types';
import { Station } from '@app/core/types/stations';

export function AuditEqualMd5ReportView(p: { station: Station }) {
  const tz = useTimezone();

  const resetValues = {
    ...toDateRange(today() as DateStr, tz),
  };

  return (
    <ReportView<EqualMd5Report>
      defaultValues={resetValues}
      download={{
        filename: 'duplicated-media',
        local: true,
        resultToExport: (result) =>
          result.items.map((item) => ({
            md5: item.md5,
            customIds: item.audios.map((a) => a.customId).join(' '),
          })),
      }}
      reportFn={(values) => {
        return apiClient.audit.stationReportsEqualMd5({
          stationId: p.station.slug,
          from: values.from,
          to: values.to,
        });
      }}
      Form={EqualMd5ReportForm}
      Result={EqualMd5ReportResult}
    />
  );
}
